module.exports = __webpack_public_path__ + "static/GreycliffCF-Medium-58428caef7164ecc422091a537c212c5.ttf";